import styles from './Status.module.css'
import { CircleColor } from './StatusTypes';

export default function StatusCircle(props: CircleColor){
    function getColor(color:string){
        let style ='';
        if (color == 'success'){
            style = styles.circlegreen
        }else if (color == 'disabled'){
            style = styles.circlegrey
        }else if (color == 'warning'){
            style = styles.circleorange
        }else if (color == 'error'){
            style = styles.circlered
        }
        return style;
        
    }

    return(
        <div
            className={`${styles.circle} ${getColor(props.color)}`}
          ></div>
    )
}
